import { render } from "./CountryFlagKeyboard.vue?vue&type=template&id=4d539911&scoped=true&ts=true&lang=pug"
import script from "./CountryFlagKeyboard.vue?vue&type=script&lang=ts"
export * from "./CountryFlagKeyboard.vue?vue&type=script&lang=ts"

import "./CountryFlagKeyboard.vue?vue&type=style&index=0&id=4d539911&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d539911"]])

export default __exports__